import { makeRequest } from '~shared/api/make-request';
import { config } from '~shared/config';

import { ResponseSuccess } from '@breezeventures/scp-client';
import { useMutation } from '@tanstack/react-query';

import type { PartnerApplicationResponse } from '../model';

type SubmitPartnerApplicationRequest = {
  applicationId: string;
};

export const useSubmitPartnerApplication = () => {
  return useMutation({
    mutationFn: (request: SubmitPartnerApplicationRequest) => {
      return makeRequest<ResponseSuccess<PartnerApplicationResponse>>({
        url: `${config.apiHost}/merchant-origination/api/v1/public/partner/applications/submit`,
        credentials: 'include',
        payload: request,
      }).then((response) => response.payload);
    },
  });
};
